import * as React from "react"
import type { SVGProps } from "react"
const SvgBag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 22.43q-.82 0-1.41-.59A2 2 0 0 1 3 20.43v-12q0-.82.59-1.41A2 2 0 0 1 5 6.42h2Q7 4.37 8.46 2.9 9.93 1.43 12 1.43c2.07 0 2.56.49 3.54 1.46A4.8 4.8 0 0 1 17 6.43h2q.83 0 1.41.59.6.59.59 1.4v12q0 .84-.59 1.42a2 2 0 0 1-1.41.59zm0-2h14v-12H5zm4-14h6q0-1.25-.87-2.13A3 3 0 0 0 12 3.43q-1.25 0-2.12.87A3 3 0 0 0 9 6.43m2.98 8q1.84 0 3.34-1.23 1.5-1.22 1.48-2.75 0-.42-.28-.72a1 1 0 0 0-.7-.3 1 1 0 0 0-.62.22q-.28.23-.4.68a2.8 2.8 0 0 1-1.07 1.52 3 3 0 0 1-1.75.58 3 3 0 0 1-1.77-.58 2.6 2.6 0 0 1-1.06-1.52q-.12-.48-.37-.69a1 1 0 0 0-.6-.21q-.43 0-.72.3a1 1 0 0 0-.28.73q0 1.52 1.47 2.74 1.48 1.23 3.33 1.23" />
  </svg>
)
export default SvgBag
